import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { EntityContentLayoutBlueprint } from '@backstage/plugin-catalog-react/alpha';

/** Port-like overview layout, used for every entity kind. */
const portEntityLayout = EntityContentLayoutBlueprint.make({
  name: 'port',
  params: {
    loader: async () =>
      import('./PortEntityLayout').then(m => m.PortEntityLayout),
  },
});

export const catalogModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [portEntityLayout],
});
